import React from 'react';
import MaterialTable from 'material-table';
import RolesGroupTransferList from './RolesGroupTransferList';
import Service from '../../config/networkutils';
import { roles_group_api } from '../../config/apiList'
import Auth from '../../utils/authenticate';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withSnackbar } from 'notistack';
import RotateCircleLoading from 'react-loadingg/lib/RotateCircleLoading';
import { getDataIsdeletedFalse, getPrimaryColor } from '../Helper/CommonThings';


const token = Auth.token();

class RolesGroup extends React.Component {
    constructor() {
        super();
        this.state = {
            data: [],
            roles: [],
            addGroupName: false,
            groupName: '',
            isLoading: true,
            deleteDialog: false,
            deleteData: {},
            rowData: null,
            allBusinessUnits: [],
            selectedBU: {},
            openLinkDialog: false,
            selectedData: {}
        }
    }

    componentDidMount() {
        this.fetchOps();
        this.fetcRoleGroups()
        this.fetchBusinessUnits()
    }

    linkBU() {
        let data = {
            role_group: this.state.selectedData.id,
            business_unit: this.state.selectedBU.id
        }
        Service.post('/api/role/group/link_role_group_business_unit/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        })
            .then(res => {
                // this.setState({ isLoading: true, })
                this.fetchOps();
                this.props.enqueueSnackbar('Business Unit successfully linked to Role Group', {
                    variant: 'success'
                });
            })
            .catch(error => {
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
    }

    fetchBusinessUnits() {
        Service.get('/api/business/unit/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                // this.setState({ isLoading: true, })
                this.setState({
                    allBusinessUnits: res.data
                })

            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });
            })
    }

    fetchOps() {
        Service.get('/api/roles/get_business_unit_roles/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                let archive = []; let live = [];
                resData.forEach(role => {
                    if (role.is_active === true) {
                        live.push(role)
                    }
                    else archive.push(role)
                })
                // this.live = live;
                // this.archive = archive;


                this.setState({ roles: live })
            })
            .catch(error => {
                if (error.status === 403) {
                    this.props.enqueueSnackbar(error.data.message, {
                        variant: 'warning'
                    });
                } else {
                    this.props.enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                }
            })
    }

    fetcRoleGroups() {
        Service.get('/api/role/group/get_business_unit_role_groups/', {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                let resData = getDataIsdeletedFalse(res.data);
                this.setState({ data: resData }, () => {
                    this.setState({
                        isLoading: false
                    })
                })

            })
            .catch(error => {
                this.setState({
                    isLoading: false
                })
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });

            })
    }

    addRoleGroup(name) {
        this.setState({ isLoading: true })
        Service.post('/api/role/group/', {
            headers: {
                Authorization: "Token " + token,
            },
            data: {
                name: name
            }
        })
            .then(res => {
                this.props.enqueueSnackbar('Role group name successfully added', {
                    variant: 'success'
                });
                this.fetcRoleGroups()
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });

            })
    }

    groupNameSubmit = () => {

        this.addRoleGroup(this.state.groupName)
    }

    deleteRoleGroup = () => {
        Service.get(`/api/role/group/role_group_deletion/?role_group=${this.state.rowData.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.props.enqueueSnackbar('Role group deleted successfully', {
                    variant: 'success'
                });
                this.setState({
                    deleteDialog: false
                })
                this.fetcRoleGroups()
            })
            .catch(error => {
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error'
                });

            })
    }

    render() {

        const handleClose = () => {
            this.setState({ addGroupName: false })
        }

        const handleDeleteDialog = () => {
            this.setState({ deleteDialog: false })
        }

        return (
            <div>
                {this.state.isLoading ? <RotateCircleLoading color={getPrimaryColor()} /> :
                    <div>
                        <MaterialTable
                            title="Roles Group"
                            columns={[
                                { title: 'Role Group Name', field: 'name' },
                            ]}
                            data={this.state.data}
                            detailPanel={rowData => {
                                return (
                                    <RolesGroupTransferList roles={this.state.roles} rowData={rowData} />
                                )
                            }}
                            onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            actions={[
                                {
                                    icon: 'add',
                                    tooltip: 'Add Role Group',
                                    isFreeAction: true,
                                    onClick: (event) => {
                                        this.setState({ addGroupName: true })
                                    }
                                },
                                rowData => {
                                    return {
                                        icon: 'delete',
                                        tooltip: 'Delete Role Group',
                                        isFreeAction: true,
                                        onClick: (event) => {
                                            this.setState({
                                                rowData: rowData,
                                                deleteDialog: true
                                            })
                                        }
                                    }
                                },
                                // rowData => ({
                                //     icon: () => <AllInclusiveIcon />,
                                //     tooltip: 'View linked business units',
                                //     onClick: (event, rowData) => {
                                //         this.setState({
                                //             openLinkDialog: true,
                                //             selectedData: rowData,
                                //         })

                                //     }
                                // })
                            ]}
                            options={{
                                paging: false,
                                pageSize: 20,
                                pageSizeOptions: [10, 20, 50, 100],
                                headerStyle: {
                                    fontWeight: 'bold',
                                },
                                // padding:'dense',
                                search: false
                            }}

                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve, reject) => {

                                        Service.put(roles_group_api + newData.id + "/", {
                                            headers: {
                                                Authorization: "Token " + token,
                                            },
                                            data: newData
                                        })
                                            .then(res => {
                                                this.props.enqueueSnackbar('Role group name successfully updated', {
                                                    variant: 'success'
                                                });
                                                this.fetcRoleGroups()
                                                resolve();
                                            })
                                            .catch(error => {
                                                this.props.enqueueSnackbar('Something went wrong!', {
                                                    variant: 'error'
                                                });

                                                resolve();
                                            })

                                    }),
                                // onRowDelete: oldData =>
                                // new Promise((resolve, reject) => {
                                //     // setTimeout(() => {
                                //     //     const dataDelete = [...data];
                                //     //     const index = oldData.tableData.id;
                                //     //     dataDelete.splice(index, 1);
                                //     //     setData([...dataDelete]);

                                //     //     resolve();
                                //     // }, 1000);
                                //     // this.setState({
                                //     //     deleteData: oldData
                                //     // },() =>{
                                //     //     this.setState({
                                //     //         deleteDialog: true
                                //     //     })
                                //     // })
                                //     this.deleteRoleGroup(oldData)
                                //     resolve()

                                // })
                            }}
                        />

                        <Dialog open={this.state.addGroupName} onClose={handleClose}>
                            <DialogTitle>Add Group Name</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Please enter group name in below field to add in table
                                </DialogContentText>
                                <TextField
                                    autoFocus
                                    margin="dense"
                                    id="groupName"
                                    label="Group Name"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    onChange={e => this.setState({ groupName: e.target.value })}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button color='secondary' onClick={handleClose}>Cancel</Button>
                                <Button onClick={() => {
                                    this.groupNameSubmit();
                                    handleClose()
                                }}>Submit</Button>
                            </DialogActions>
                        </Dialog>
                        <Dialog open={this.state.deleteDialog} onClose={handleDeleteDialog}>
                            <DialogTitle>Delete Role Group</DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    Are you sure. You want to delete the respective Role Group
                                </DialogContentText>
                                {/* <TextField
                                    autoFocus
                                    margin="dense"
                                    id="groupName"
                                    label="Group Name"
                                    type="text"
                                    fullWidth
                                    variant="standard"
                                    onChange={e => this.setState({ groupName: e.target.value })}
                                /> */}
                            </DialogContent>
                            <DialogActions>
                                <Button color='primary' onClick={handleDeleteDialog}>Cancel</Button>
                                <Button color='primary' onClick={() => {
                                    this.deleteRoleGroup();
                                    handleDeleteDialog()
                                }}>Delete</Button>
                            </DialogActions>
                        </Dialog>
                        {/* <Dialog open={this.state.openLinkDialog} onClose={() => this.setState({ openLinkDialog: false })} maxWidth="xs" fullWidth  >
                            <DialogTitle>Linked Business Units</DialogTitle>
                            <DialogContent>
                                <Autocomplete
                                    options={this.state.allBusinessUnits}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option.name}
                                    onChange={(e, value) => this.setState({ selectedBU: value })}
                                    size='small'
                                    value={this.state.selectedBU}
                                    renderInput={(params) => (
                                        <TextField {...params} size='small' variant="outlined" label="Link Business Unit to Role" placeholder="Link Business Unit to Role" />
                                    )}
                                />
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={() => this.setState({ openLinkDialog: false })} color="primary">
                                    Close
                                </Button>
                                <Button onClick={() => this.linkBU()} color="primary">
                                    Submit
                                </Button>
                            </DialogActions>
                        </Dialog> */}
                    </div>
                }
            </div>
        )
    }
}

export default withSnackbar(RolesGroup)